// Read-only recap of org divisions chosen in the onboarding "structure" step.

import React from 'react';
import StructureRecapStrip from '../shared/StructureRecapStrip';

export default function MembersOnboardingEndingStructureStrip({ cards }) {
  return (
    <StructureRecapStrip
      cards={cards}
      dataResource="members.onboarding.ending"
      dataDescription="Onboarding ending — structure recap"
      rootClassName="members-onboarding-ending-structure"
    />
  );
}
